import ContactForm from "@/components/forms/contact-form";

export default function ContactUs() {
  return (
    <div className="relative  z-10  mx-auto  flex max-w-4xl  flex-1 flex-col items-center gap-5 px-6  py-24 sm:gap-10">
      <div className="flex flex-col items-center  gap-3 ">
        <p className="eyebrow">Get in touch</p>
        <h1 className="text-center text-5xl">Contact us</h1>
        <p className=" text-center text-[#2b2c30]">
          Send us a message and we'll get back to you.
        </p>
      </div>
      <div className="w-full  max-w-2xl">
        <ContactForm />
      </div>
    </div>
  );
}
